import { render, staticRenderFns } from "./ContentStatus.vue?vue&type=template&id=06f23113"
import script from "./ContentStatus.vue?vue&type=script&lang=js"
export * from "./ContentStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports